

    <section *ngFor="let group of groups">
      <h3>{{ group.name }}</h3>
      <p>{{ group.description }}</p>
      <div class="collection">
        <wf-vertex-library-item *ngFor="let vertex of group.vertices" (click)="clicked.emit(vertex)"
                                [vertex]="vertex"></wf-vertex-library-item>
      </div>

    </section>

  


// WEBPACK FOOTER //
// ./src/library/vertex-library/workflow-vertex-library.component.ts.WorkflowVertexLibraryComponent.html